import React from "react"
import AsyncSelect from "react-select/lib/Async";
import {IoIosAddCircle, IoMdArrowDropdown, IoIosCloseCircle, IoMdArrowDropup} from "react-icons/io"
import "./accounts.css"
import ApiService from "../../../Services/ApiService.js"
import Papa from "papaparse"
import ReactTable from "react-table";
import AlertService from "../../../Services/AlertService";
import ImageDropzone from "./imageDropzone";
import $ from 'jquery';

class Accounts extends React.Component {

    state = {
        campaign_companies: [],
        client_companies: [],
        common_names: [],
        hide_accounts: false,
        account_id_input: -1,
        account_common_name_input : '',
        account_url_input: '',
        account_company_search_input: '',
        account_localized_name: '',
        account_vanity_name: '',
        account_file_identifier: '',
        account_linkedin_url: '',
        account_owner: '',
        client_id: '',
        campaign_id: '',
        audience_sizes: [],
        default_audience: {},
        table_data: [],
        table_loading: false,
        csvFile: null,
        selected_company: '',
        toggle_all: false,
        total_audience_size: 0,
        low_audience_accounts: 0
    };

    componentDidMount = () => {
        if (this.props.data) {
            this.setState({
                ...this.state,
                client_id: this.props.data.clientId,
                campaign_id: this.props.data.campaignId
            }, () => {
                this.fetchCampaignDefaults();
                
            });
        }
    };
    
    handleChange = (event) => {
        const {name, value, type, checked} = event.target;// React's Synthetic Event
        type === "checkbox" 
            ? 
            this.props.updateState({ [name] : checked }) 
            : 
            this.props.updateState({ [name] : value });
    };

    fetchCampaignCompanies = () => {
        let campaign_id = this.props.data.campaignId;
        ApiService.get('/api/campaigns/linkedin-companies?campaign_id=' + campaign_id).then(response => {
            var companies = this.getLinkedInLocalizedNames(response.data.Companies);
            
            this.setState({
                campaign_companies: response.data.Companies,
                client_companies: companies,
            }, () => {
                this.setState({
                    table_data: this.buildTableData()
                });
            });
            
        });
    };
    
    buildTableData = () => {
        let data = JSON.parse(JSON.stringify(this.state.campaign_companies));
        let audience_sizes =this.state.audience_sizes;

        let totalAudience = 0;
        let lowAudienceAccounts = 0;

        for (let i = 0; i < data.length; i++) {
            data[i]['audience_option_sizes'] = ['-', '-','-', '-', '-', '-', '-'];
            data[i]['active'] = false;

            if ("job_functions" in data[i] && "seniorities" in data[i] && "locations" in data[i]) {

                    let jobfunctions = data[i]['job_functions'].sort().join(',');
                    let defjobfunctions = this.state.default_audience['job_functions'].sort().join(',');
                    let seniorities = data[i]['seniorities'].sort().join(',');
                    let defseniorities = this.state.default_audience['seniorities'].sort().join(',');
                    let locations = data[i]['locations'].sort().join(',');
                    let deflocations = this.state.default_audience['locations'].sort().join(',');

                    if(jobfunctions === defjobfunctions){
                        data[i]['job_functions'] = 'Default';
                    } else {
                        data[i]['job_functions'] = data[i]['job_functions'].length > 0 ? data[i]['job_functions'].join(", ") : 'None';
                    }

                    if(seniorities === defseniorities) {
                        data[i]['seniorities'] = 'Default';
                    } else {
                        data[i]['seniorities'] = data[i]['seniorities'].length > 0 ? data[i]['seniorities'].join(", ") : 'None';
                    }

                    if(locations === deflocations) {
                        data[i]['locations'] = 'Default';
                    } else {
                        data[i]['locations'] = data[i]['locations'].length > 0 ? data[i]['locations'].join(", ") : 'None';
                    }

            } else {
                data[i]['job_functions'] = 'Default';
                data[i]['seniorities'] = 'Default';
                data[i]['locations'] = 'Default';

            }

            let audienceSize = data[i]['audience_size'];
            totalAudience += audienceSize;

            if (!audienceSize) {
                lowAudienceAccounts++;
            }
        }

        this.setState({ ...this.state, total_audience_size: totalAudience, low_audience_accounts: lowAudienceAccounts});

        return data;
    };
    

    fetchCompany = inputValue =>
        new Promise(resolve => {
            ApiService.get("/api/linkedin/companies?search=" +inputValue.toLowerCase()+ "&client_id=" + this.state.client_id).then(response => {
                if (response.data.matches.length > 0) {
                    var matches = [];
                    for (var i = 0; i<response.data.matches.length; i++) {
                        matches.push({'value': response.data.matches[i].vanityName, 'label': response.data.matches[i].localizedName, 'id': response.data.matches[i].id});
                    }
                    resolve(matches);
                }
            });
        });

    getLinkedInLocalizedNames = (Companies) => {
        var companies = [];
        if (Companies.length > 0) {
            for (var i = 0; i < Companies.length; i++) {
                var newelement = {id: Companies[i].linkedin_company_id, localizedName: Companies[i].default_name};
                companies.push(newelement);
            }
        }
        return companies;
    };
    
    showOrHideAccounts = () => {
        let currentState = this.state.hide_accounts;
        this.setState({hide_accounts: !currentState});
    };

    handleAccountNameChange = (event) => {
        if(event.label && event.value) {
            this.setState({
                ...this.state,
                account_id_input: event.id,
                account_localized_name: event.label,
                account_vanity_name: event.value
            });
        }
    };

    handleCommonNameChange = (event) => {
        if(event && event.target && event.target.value) {
            this.setState({
                account_common_name_input: event.target.value
            });
        }
    };
    
    fetchAudienceSize = async (linkedin_company_id, job_functions, seniorities, locations) => {
        
        await ApiService.post('/api/linkedin/audience-size',
            {
                'linkedin_company_id': linkedin_company_id,
                'job_functions[]': job_functions,
                'seniorities[]': seniorities,
                'locations[]': locations,
                'client_id': this.state.client_id,
                'campaign_id': this.state.campaign_id
            }).then(response => {
                var audience_size = {'linkedin_company_id': linkedin_company_id, 'audience_size': response.data.size};

                this.setState(prevState => ({
                    audience_sizes: [...prevState.audience_sizes, audience_size],
                }), async () => {
                    let audience_sizes = this.state.audience_sizes;

    
                    for (var i = 0; i < audience_sizes.length; i++) {
                        for (var j = 0; j < this.state.table_data.length; j++) {
                            if (this.state.table_data[j]['linkedin_company_id'] === audience_sizes[i]['linkedin_company_id']) {
    
                                var table_data_copy = JSON.parse(JSON.stringify(this.state.table_data));
                                table_data_copy[j]['audience_size'] = audience_sizes[i]['audience_size'];
    
                                await this.setState(prevState => ({
                                    table_data: table_data_copy,
                                }));
                                
                                break;
                            }
                        }
                    }
                    
                    this.setState(prevState => ({table_loading: false}))
                });

        })
    };
    
    fetchCampaignDefaults = () => {
        let campaign_id = parseInt(this.props.data.campaignId);
        ApiService.get('/api/campaigns/fetch-default-audience?campaign_id=' + campaign_id)
            .then(response => {
                this.setState(prevState => ({
                    default_audience: response.data['default_audience'][0]
                }), () => {
                    this.fetchCampaignCompanies();
                });
            })
    };

    addAccount = async() => {
        if(this.state.account_id_input > -1) {
            await ApiService.post('/api/campaigns/add-linkedin-company',
                {
                    'campaign_id': this.state.campaign_id,
                    'linkedin_company_id': this.state.account_id_input,
                    'common_name': this.state.account_common_name_input,
                    'default_name': this.state.account_localized_name,
                    'file_identifier': this.state.account_file_identifier,
                    'linkedin_url': this.state.account_linkedin_url,
                    'account_owner': this.state.account_owner
                });

            var newElement = {
                id: this.state.account_id_input,
                localizedName: this.state.account_localized_name,
                vanityName: this.state.account_vanity_name
            };
            var campaignElem = {
                campaign_id: this.state.campaign_id,
                linkedin_company_id: this.state.account_id_input,
                common_name: this.state.account_common_name_input,
                default_name: this.state.account_localized_name,
                linkedin_url: this.state.account_linkedin_url,
                date_published: null
            };

            await this.setState(prevState => ({
                client_companies: [...prevState.client_companies, newElement],
                campaign_companies: [...prevState.campaign_companies, campaignElem],
                account_id_input: -1,
                account_common_name_input: '',
                account_vanity_name: '',
                account_localized_name: '',
                account_url_input: '',
                account_linkedin_url: ''
            }));

            await this.setState(prevState => ({
                table_data: this.buildTableData()
            }));
        }
    };

    
    removeAccount = (id, common_name) => {
        let currentCompanies = this.state.campaign_companies;
    
        ApiService.post('/api/campaigns/remove-linkedin-company', {'campaign_id': this.state.campaign_id, 'linkedin_company_id': id});
        let idx = currentCompanies.findIndex(company => company.linkedin_company_id === id);
        let selectedCompany = currentCompanies[idx];

        let currentTable = this.state.table_data;
        let tableIndex = currentTable.findIndex(row => row.linkedin_company_id === id);

        if(idx > -1) {
            currentCompanies.splice(idx,1);
            currentTable.splice(tableIndex,1);
            let totalAudience = this.state.total_audience_size - selectedCompany.audience_size;
            this.setState({...this.state, campaign_companies: currentCompanies, table_data: currentTable, total_audience_size: totalAudience});
        
        }
    };

    handleEdit(id) {
        this.props.history.push("/campaign/account?id=" + id + "&client_id=" + this.state.client_id + "&campaign_id=" + this.state.campaign_id);
    }

    fetchAudienceOptionSizes(index, linkedinCompanyId) {
        let campaign_id = parseInt(this.state.campaign_id);
        let linkedin_company_id = parseInt(linkedinCompanyId);

        let tableData = JSON.parse(JSON.stringify(this.state.table_data));
        tableData[index]['active'] = true;
        this.setState({...this.state,
            table_data: tableData
        });

        ApiService.get("/api/campaigns/fetch-linkedin-company-audience-options?campaign_id="+ campaign_id +"&linkedin_company_id="+linkedin_company_id)
            .then(response => {
                let result = [];
                let data = response.data.options;
                for (let i = 0; i < data.length; i++) {
                    let size = data[i]["Size"] === "Too small" ? 0 : data[i]["Size"];
                    result.push(size);
                }

                // fill extra options with '-'
                let extraOptions = 7 - data.length;
                for (let i = 0; i < extraOptions; i++) {
                    result.push("-");
                }

                // need to get a fresh copy of the table_data in case of other rows that have been updated
                tableData = JSON.parse(JSON.stringify(this.state.table_data));
                tableData[index]['audience_option_sizes'] = result;
                tableData[index]['audience_options'] = data;

                this.setState({...this.state,
                    table_data: tableData
                });
            })
    }

    handleOptionSave = (rowNum, optionNum) => {
        let tableData = JSON.parse(JSON.stringify(this.state.table_data));
        let account = tableData[rowNum];
        let option = account['audience_options'][optionNum];

        let campaignId = account['campaign_id'];
        let linkedinCompanyId = account['linkedin_company_id'];
        let jobFunctions = option['JobFunctions'];
        let seniorities = option['Seniorities'];
        let locations = option['Locations'];
        let audienceSize = option['Size'];

        const requestObj = {
            campaign_id: campaignId,
            linkedin_company_id: linkedinCompanyId,
            job_functions: jobFunctions,
            seniorities: seniorities,
            locations: locations,
            audience_size: audienceSize
        };

        ApiService.post("/api/campaigns/update-linkedin-company-audience-options", requestObj)
            .then(response => {
                this.fetchCampaignCompanies();

            })
            .catch(error => {
                AlertService.error('Oops! There was an error saving the account audience option');
            });

    };

    handleFileChange(e) {
        this.setState({...this.state,
            csvFile: e.target.files[0]

        })
    }

    uploadFile()
    {
        if (this.state.csvFile) {
            
            let uploadInfoEl = document.getElementById('upload-info');
            uploadInfoEl.innerHTML = 'Uploading accounts...';
            uploadInfoEl.style.display = 'block';

            let message = '';

            ApiService.post('/api/campaigns/import-accounts', {'campaign_id': this.state.campaign_id, 'file': this.state.csvFile})
            .then(response => {
                if (response.data.Success) {
                    this.fetchCampaignCompanies();

                    let successCount = response.data.Success.length;
                    let skipped = response.data.Skipped;
                    let failed = response.data.Fail;
    
                    message = successCount + ' account(s) uploaded successfully. <br>'
    
                    if (skipped.length) {
                        message += skipped.length + ' account(s) skipped because the account already exists or it was invalid: ' + skipped.join(', ') + '<br>';
                    }
    
                    if (failed.length) {
                        message += failed.length + ' account(s) failed because it was not found: ' + [failed.slice(0, -1).join(', '), failed.slice(-1)[0]].join(failed.length < 2 ? '' : ' and ')
                    }
    
                    
                } else {
                    message = 'Invalid file'
                }
            
                uploadInfoEl.innerHTML = message;
            })
        }

    }

    populateAudiences(){

        $('#populateAudiences').prop('disabled', true);

        let campaign_id = parseInt(this.state.campaign_id);

        ApiService.post("/api/campaigns/bulk-update-linkedin-company-audience-options",
            {
                campaign_id: campaign_id
            })
            .then(response => {
                this.fetchCampaignCompanies();
                $('#populateAudiences').prop('disabled', false);
            })
    }


    toggleSecondaryCompany(companyID)
    {
        for (var i = 0; i < this.state.table_data.length; i++) {
            if (this.state.table_data[i]['linkedin_company_id'] === companyID) {
                var data = JSON.parse(JSON.stringify(this.state.table_data));
                var includeSecondaryCompanies = !this.state.table_data[i]['secondary_companies'];
                includeSecondaryCompanies = includeSecondaryCompanies ? 1 : 0;
                data[i]['secondary_companies'] = includeSecondaryCompanies;

                this.setState(prevState => ({
                    table_data: data,
                }), async () => {
                    await ApiService.post("/api/campaigns/update-linkedin-company",
                        {
                            campaign_id: this.state.campaign_id,
                            linkedin_company_id: companyID,
                            secondary_companies: includeSecondaryCompanies
                        });

                    let campaignCompany = this.state.campaign_companies[i];

                    // only update audience size if the audience size was already set previously
                    if (campaignCompany['audience_size'] !== 0) {
                        await this.fetchAudienceSize(campaignCompany['linkedin_company_id'], campaignCompany['job_functions'], campaignCompany['seniorities'], campaignCompany['locations']);

                        ApiService.post("/api/campaigns/update-linkedin-company",
                            {
                                campaign_id: this.state.campaign_id,
                                linkedin_company_id: companyID,
                                audience_size: this.state.table_data[i]['audience_size']
                            });
                    }

                });

                break;
            }
        }
    }

    toggleAllSecondaryCompanies()
    {
        var toggleAll = !this.state.toggle_all;
        var includeSecondaryCompanies = toggleAll ? 1 : 0;

        ApiService.post("/api/campaigns/bulk-update-campaign-companies",
            {
                campaign_id: this.state.campaign_id,
                secondary_companies: includeSecondaryCompanies
            })
            .then(response => {

                var table_data_copy = JSON.parse(JSON.stringify(this.state.table_data));

                for (var j = 0; j < this.state.table_data.length; j++) {
                    table_data_copy[j]['secondary_companies'] = includeSecondaryCompanies;
                }

                this.setState(prevState => ({
                    table_data: table_data_copy,
                    toggle_all: toggleAll
                }));
            });

    }

    editSecondaryAccounts()
    {
        this.props.history.push("/campaign/secondary-accounts?client_id=" + this.state.client_id +  "&campaign_id=" + this.state.campaign_id);
    }

    render() {
        const promiseOptions = inputValue => this.fetchCompany(inputValue);
        
        const columns = [
            {
                Header: "LinkedIn URL",
                accessor: "linkedin_url",
                width: 325,
                style: { 'whiteSpace': 'unset' },
                Cell: e => {
                    let link = e.value;
                    if(link != '' && !link.startsWith("http")) {
                        link = "https://www." + e.value;
                    }
                    return (
                        <div><a href={link} target="_blank" rel="noopener noreferrer"> {link} </a></div>
                    )
                }
            },
            {
                Header: "Common Name",
                accessor: "common_name",
                width: 125
            },
            {
                Header: (

                    <div ><label>Secondary Companies</label>
                        <input type="checkbox" onChange={() => this.toggleAllSecondaryCompanies()} />
                    </div>),
                accessor: "secondary_companies",
                width: 170,
                sortable: false,
                Cell: (data) => {
                    var linkedin_company_id = data.row._original.linkedin_company_id;

                    return (

                        <div>
                            <input type="checkbox" name="remember"
                            onChange={()=> this.toggleSecondaryCompany(linkedin_company_id)}

                            checked={data.row._original.secondary_companies} />
                        </div>
                    )
                }
            },
            {
                Header: "Audience Size",
                accessor: 'audience_size',
                style: {'whiteSpace': 'unset'},
                width: 110,
                Cell: (data) => {
                    let audience_size = data.row._original.audience_size;

                    if (audience_size) {
                        return (
                            <p>{audience_size}</p>
                        )
                    } else {
                        return (
                            <p style={{ color: "red" }}>{audience_size}</p>
                        )
                    }
                    
                },
            },
            {
                Header: "Published",
                Cell: (data) => {
                    let date_published = data.row._original.date_published;
                    let published = date_published === null ? "No" : "Yes";
                    return (
                        <div>
                            <p>{ published }</p>
                        </div>
                    )
                },
                width: 110
            },
            {
                Header: "Actions",
                Cell: (data) => {
                    let index = data.index;
                    let linkedinCompanyId = data.row._original.linkedin_company_id;
                    let common_name = data.row._original.common_name;
                    return(
                        <div>
                        <button className="table-btn edit-btn" onClick={() => this.handleEdit(linkedinCompanyId) }> <i className="fa fa-edit"></i> </button>
                        <button className="table-btn" onClick={() => this.removeAccount(linkedinCompanyId, common_name)}> <i className="fa fa-trash-o"></i> </button>
                        <button disabled={data.row._original.active} className="find-now-btn" onClick={() => this.fetchAudienceOptionSizes(index, linkedinCompanyId)}> <i className="fa fa-search"></i> Get Options </button>
                        </div>

                    )
                },
                width: 215
            },
            {
                id: 'audience_options',
                Header: "Audience Options",
                style: {'whiteSpace': 'unset'},
                Cell: (data) => {
                    let rowNum = data.index;

                    return(
                        <div>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 0) }> {data.row._original.audience_option_sizes[0]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 1) }> {data.row._original.audience_option_sizes[1]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 2) }> {data.row._original.audience_option_sizes[2]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 3) }> {data.row._original.audience_option_sizes[3]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 4) }> {data.row._original.audience_option_sizes[4]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 5) }> {data.row._original.audience_option_sizes[5]} </button>
                            <button className="option-btn" onClick={() => this.handleOptionSave(rowNum, 6) }> {data.row._original.audience_option_sizes[6]} </button>
                        </div>

                    )
                }
            },
        ];
        
        let $accountsListing = null;
        if (this.state.table_data.length !== 0) {
            $accountsListing = (
                <ReactTable
            loading={this.state.table_loading}
            data={this.state.table_data}
            columns={columns}
            showPagination={true}
            minRows={0}
            defaultPageSize={100}
            resizable={false}
            />
            )
        }

        return(
            <div className="accounts-ads">
                <div id="upload-info" className="alert alert-primary">
                </div>
                <div className="body">
                    <div className="section">
                        <div className="title">
                            Accounts Bulk File Upload
                        </div>
                    </div>
                    <div className="section upload-file-section">

                        <input id="upload-file" type="file" accept=".xls, .xslx, .csv" onChange={(e)=>this.handleFileChange(e)}/>
                        <button onClick={this.uploadFile.bind(this)}>Upload File</button>
                </div>

                <div className="section">
                    <div className="title">
                        Account Ad Image Bulk File Upload
                    </div>
                </div>
                <div>
                    <ImageDropzone campaignID={this.state.campaign_id}/>
                </div>

                <div className="space-between"></div>

                    <div className="kpi-container">
                        <div className="kpi-card blue">
                            <span className="card-value">{this.state.total_audience_size}</span>

                            <span className="card-text">Total Audience</span>
                            <i className="fa fa-users icon"></i>
                        </div>
                        
                        <div className="kpi-card blue">
                            <span className="card-value">{this.state.low_audience_accounts}</span>

                            <span className="card-text">Low Audience Accounts</span>
                            <i className="fa fa-user-times icon"></i>
                        </div>
                    </div>
                  
            </div>

            <div className="section">
                    <div onClick={this.showOrHideAccounts} hidden={this.state.hide_accounts}>
                        <IoMdArrowDropdown className="arrow-icon"/>
                    </div>
                    <div onClick={this.showOrHideAccounts} hidden={!this.state.hide_accounts}>
                        <IoMdArrowDropup className="arrow-icon"/>
                    </div>
                    <div className="title">
                        Accounts
                    </div>
                </div>
                <div className="body" hidden={this.state.hide_accounts}>
                    <div>
                        <button onClick={this.editSecondaryAccounts.bind(this)}> Edit Secondary Accounts </button>
                        <button id="populateAudiences" onClick={this.populateAudiences.bind(this)}>Populate Audiences</button>
                    </div>
                    <div className="table-style">
                        {$accountsListing}
                    </div>
                </div>
            </div>
        )
    }
}

export default Accounts;